/**
 * DraftProposalPreviewEntry — team-only card for a proposal that's still being drafted (not yet
 * posted, so it has no real journey_entries row of its own). JourneyPreviewOverlay.jsx injects a
 * SYNTHETIC entry of this type (never persisted, never seen by the real client) when its own
 * "Show draft proposal" toggle is on, so a team member can check how the journey will read once
 * this proposal is actually posted, without posting it.
 *
 * Deliberately simple: no packages, no fee figures (that's the SigningModal/PDF's job, not a
 * teaser here — matches ProposalReviewEntry.jsx's own current design, which dropped pricing from
 * the card entirely). Opens straight to the document via the same 3D JourneyBook cover every other
 * full-screen journey document (presentations, drawing sets, reports) uses — clicking it opens the
 * current draft directly, no separate buttons to choose between.
 *
 * "Open" reuses the same Clerk-authed preview functions CrmProposalDetailModal.jsx's own "Preview
 * web view"/"Preview PDF" buttons already call (services/proposals.js) — safe here because this
 * component only ever renders inside the in-app, authenticated JourneyPreviewOverlay, never on the
 * public /journey page. Basic Services opens the live web view; anything else (e.g. Design
 * Consultation, which has no web-view body) opens the working PDF instead.
 */
import { J } from '../journeyUI.jsx'
import JourneyBook from './JourneyBook.jsx'
import { previewProposalPdf, previewProposalHtml } from '../../services/proposals.js'

async function openDraft(d) {
  const tab = window.open('', '_blank')
  try {
    const url = d.type === 'Basic Services' ? await previewProposalHtml(d.id, { working: true }) : await previewProposalPdf(d.id, { working: true })
    if (tab) tab.location = url; else window.open(url, '_blank')
  } catch { if (tab) tab.close() }
}

export default function DraftProposalPreviewEntry({ entry }) {
  const d = entry.data || {}
  return (
    <div>
      <div style={J.eyebrow}>{d.type || 'Proposal'}</div>
      <h2 style={J.title}>Your proposal is ready</h2>
      <hr style={J.rule} />
      <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 6px' }}>
        <JourneyBook label="Proposal" aspect={8.5 / 11} onOpen={() => openDraft(d)} caption="Preview — being drafted, not yet posted" />
      </div>
    </div>
  )
}
